"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _ActionNamespaces = require("crm_data/actions/ActionNamespaces");

var _TicketsAPI = require("crm_data/tickets/api/TicketsAPI");

var _LazyKeyStore = require("crm_data/store/LazyKeyStore");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _toString = _interopRequireDefault(require("transmute/toString"));

(0, _LazyKeyStore.registerLazyKeyService)({
  namespace: _ActionNamespaces.TICKETS,
  fetch: _TicketsAPI.fetch
});

var _default = (0, _LazyKeyStore.defineLazyKeyStore)({
  namespace: _ActionNamespaces.TICKETS,
  idIsValid: function idIsValid(id) {
    return typeof id === 'string' || typeof id === 'number';
  },
  idTransform: _toString.default
}).defineResponseTo(_ActionTypes.TICKETS_CREATE_SUCCEEDED, function (state, ticket) {
  var id = ticket.objectId;
  return state.set(id, ticket);
}).defineResponseTo([_ActionTypes.TICKETS_UPDATE_STARTED, _ActionTypes.TICKETS_UPDATE_SUCCEEDED], function (state, _ref) {
  var id = _ref.id,
      nextProperties = _ref.nextProperties;

  if (!state.has(id)) {
    return state;
  }

  return state.updateIn([id], function (ticket) {
    return nextProperties.reduce(function (acc, value, name) {
      return (0, _ImmutableModel.setProperty)(acc, name, value);
    }, ticket);
  });
}).defineResponseTo(_ActionTypes.TICKETS_UPDATE_FAILED, function (state, _ref2) {
  var id = _ref2.id,
      nextProperties = _ref2.nextProperties,
      properties = _ref2.properties;
  return state.updateIn([id], function (ticket) {
    return properties.reduce(function (acc, value, name) {
      if (nextProperties.get(name) !== (0, _ImmutableModel.getProperty)(acc, name)) {
        return acc;
      }

      return (0, _ImmutableModel.setProperty)(acc, name, value);
    }, ticket);
  });
}).defineName('TicketsStore').register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;